import { IRoomOption } from 'components/Pages/Admin/Itinerary/Details/RoomsSelect/types';
import { IRoom } from 'components/shared/Assets/shared/Form/Document/types';
import { IRooming } from 'detailsv2/structure';

import { TAccommodationEventData } from '../types';

/*
TODO rework selector | I need to create a selector in such a way that we don't 
have to explicitly cast data types for value/label. The selector should work in 
a way that it can accept any data structure, and with the help of additional helpers, 
it should determine what is considered the label and what is considered the value
*/
export const roomToOptionAdapter = (props: IRooming | IRoom): IRoomOption => {
  const label = props.name || (props as any).label || '';
  const value = (props.id || (props as any).value || '').toString();

  if ('media' in props) {
    return {
      label: label,
      value: value,
      ...(props.media && { media: props.media }),
    };
  }

  return {
    label: label,
    value: value,
    ...(props.isCustom && { isCustom: props.isCustom }),
    ...(props.count && { count: props.count }),
  };
};

export const getHandleAccommodationData =
  (setCreatedRooms: (rooms: IRoomOption[]) => void) => (data: TAccommodationEventData) => {
    if (!data?.rooming) return data;

    const customRooming = data.rooming.map((roomingItem) => ({
      ...roomingItem,
      label: roomingItem.name || '',
      value: roomingItem.id || '',
    }));

    setCreatedRooms(customRooming);
    const handledData = { ...data, rooming: customRooming };

    return handledData;
  };
